"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
exports.ListDateComponent = (props) => {
    return React.createElement("p", null, props.field.showTimeSelect ? moment(props.model).format("LLL") : moment(props.model).format("ll"));
};
//# sourceMappingURL=ListDateComponent.js.map